<template>
  <div id="pageRoot">
    <div class="textBubble" style="width:500px; height: 100px; left: 90px; margin-top: 50px;">
      <div class="textContainer textBase center" style="width: 90%; height: 90%;">
          <p class="center">¡Felicitaciones!<br>Completaste el album.</p>
      </div>
      <img class="arrow" src="/pages/img/general/textBubbleArrow.svg" style="top: 80px; left:360px;"/>
    </div>

     <img src="/pages/img/album/assets_p5/zorrito.svg" style="width: 560px; margin-left: 450px; margin-top: 110px; position: absolute; z-index: 1" class="bouncingItem" />

    <img src="/pages/img/album/assets_p5/X.svg" style="position: absolute; height: 65px; left: 60px; top: 407px;" class="basicItem01" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <img src="/pages/img/album/assets_p5/Y.svg" style="position: absolute; height: 65px; left: 60px; top: 507px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <img src="/pages/img/album/assets_p5/Z.svg" style="position: absolute; height: 65px; left: 60px; top: 607px;" class="basicItem02" />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 307px;
}
#inputField02 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 407px;
}
#inputField03 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 507px;
}
#inputField04 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 607px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["alb/Video 4.mp4"],
    }
  }
}
</script>